import "../stylesheets/App.css";
import "../stylesheets/Register.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PopupRegister from "./subcomponents/PopupRegister.js";
import Loader from "./subcomponents/Loader.js";

function Register() {
  const navigate = useNavigate();

  const [loadingRegister, setLoadingRegister] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [name, setName] = useState("");
  const [cedula, setCedula] = useState("");
  const [age, setAge] = useState("");
  const [phone, setPhone] = useState("");

  const [marketing, setMarketing] = useState("FB");
  const [idCountry, setIdCountry] = useState(1);

  // 👈 NUEVO - estados de los 3 campos nuevos
  const [ciudad, setCiudad] = useState("");
  const [tieneMoto, setTieneMoto] = useState(""); // "si" | "no" | ""
  const [cualMoto, setCualMoto] = useState("");

  const [acepto, setAcepto] = useState(false);

  const [activePopup, setActivePopup] = useState(false);
  const [user, setUser] = useState({});

  // STATES TO SHOW ERRORS
  const [nameError, setNameError] = useState(false);
  const [cedulaError, setCedulaError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [ageError, setAgeError] = useState(false);
  const [aceptoError, setAceptoError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  // 👈 NUEVO - errores de los campos nuevos
  const [ciudadError, setCiudadError] = useState(false);
  const [tieneMotoError, setTieneMotoError] = useState(false);
  const [cualMotoError, setCualMotoError] = useState(false);

  const [showPass, setShowPass] = useState(false);

  // ✅ redirect seguro (no en render)
  useEffect(() => {
    const raw = localStorage.getItem("user-info");
    if (!raw) return;

    const parsed = JSON.parse(raw);
    if (parsed?.is_admin) navigate("/admin");
    else navigate("/");
  }, [navigate]);

  useEffect(() => {
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "auto";
  }, []);

  // SAVE USER
  const register = async () => {
    setLoadingRegister(true);
    setErrorMsg("");

    setNameError(false);
    setCedulaError(false);
    setPhoneError(false);
    setEmailError(false);
    setAgeError(false);
    setAceptoError(false);
    setPasswordError(false);
    setCiudadError(false);       // 👈 NUEVO
    setTieneMotoError(false);    // 👈 NUEVO
    setCualMotoError(false);     // 👈 NUEVO

    const idCategory = 1;

    const passwordOk = password && password.length >= 8 && password.length <= 12;

    // 👈 NUEVO - si dice "sí" tiene que completar el modelo; si dice "no", no
    const motoOk = tieneMoto === "no" || (tieneMoto === "si" && cualMoto.trim() !== "");

    // ✅ validaciones front (early return)
    if (!name || !cedula || !email || !age || !phone || !idCountry || !passwordOk || !acepto
      || !ciudad || !tieneMoto || !motoOk) {                                              // 👈 NUEVO
      setNameError(!name);
      setCedulaError(!cedula);
      setPhoneError(!phone);
      setEmailError(!email);
      setAgeError(!age);
      setAceptoError(!acepto);
      setPasswordError(!passwordOk);
      setCiudadError(!ciudad);                                       // 👈 NUEVO
      setTieneMotoError(!tieneMoto);                                 // 👈 NUEVO
      setCualMotoError(tieneMoto === "si" && !cualMoto.trim());      // 👈 NUEVO
      setErrorMsg("Debe completar todos los campos");
      setLoadingRegister(false);
      return;
    }

    const item = {
      name,
      cedula,
      email,
      age,
      phone: phone.toString().startsWith("+506") ? phone : "+506" + phone.toString(),
      marketing,
      idCountry,
      password,
      idCategory,
      acepto,
      // 👈 NUEVO - los 3 campos al body que va a la API
      ciudad,
      tieneMoto: tieneMoto === "si" ? 1 : 0,
      cualMoto: tieneMoto === "si" ? cualMoto : null,
    };

    try {
      let result = await fetch(process.env.REACT_APP_API_BASE_URL + "/users/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      const json = await result.json();

      if (json.status === 200) {
        setUser(json.data);
        setActivePopup(true);

        // envío mail validación
        await fetch(process.env.REACT_APP_API_BASE_URL + "/users/sendMailValidate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        });

        localStorage.setItem("user-email", JSON.stringify(json.data.email));
      } else {
        const msg = json?.data?.errors?.[0]?.msg || "Error al registrar";
        setErrorMsg(msg);

        if (msg === "El email ingresado ya está en uso. Iniciá sesión!") {
          setEmailError(true);
        }
      }
    } catch (e) {
      console.log(e);
      setErrorMsg("Error de red, intentá de nuevo");
    } finally {
      setLoadingRegister(false);
    }
  };

  return (
    <>
      <div
        className="back-container"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/register/pelotas-registro-completo.webp)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center top",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <div className="register-container section-70">
          <img className="banner-reg" src={process.env.PUBLIC_URL + "/images/logo-registro.png"} />

          {/* NOMBRE */}
          <div className="inp">
            <input
              className="inp-reg"
              type="text"
              placeholder="Nombre completo"
              id="name"
              name="name"
              value={name}
              onChange={(e) => {
                const result = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ ]/g, "");
                setName(result);
              }}
            />
            {nameError && (
              <>
                <div className="error-message">Por favor agrega el nombre completo</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* ID */}
          <div className="inp">
            <input
              className="inp-reg"
              type="number"
              placeholder="Número de identificación"
              id="cedula"
              name="cedula"
              onChange={(e) => setCedula(e.target.value)}
            />
            {cedulaError && (
              <>
                <div className="error-message">Por favor agrega número de identificación</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* TELÉFONO */}
          <div className="inp">
            <input
              className="inp-reg"
              type="number"
              placeholder="Número de teléfono"
              id="phone"
              name="phone"
              onChange={(e) => setPhone(e.target.value)}
            />
            {phoneError && (
              <>
                <div className="error-message">Por favor agrega número de teléfono</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* EMAIL */}
          <div className="inp">
            <input
              className="inp-reg"
              type="text"
              placeholder="Correo electrónico"
              id="email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
            />
            {emailError && (
              <>
                <div className="error-message">Por favor agrega un email válido</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* EDAD */}
          <div className="inp">
            <input
              className="inp-reg"
              type="number"
              placeholder="Edad"
              id="age"
              name="age"
              onChange={(e) => setAge(e.target.value)}
            />
            {ageError && (
              <>
                <div className="error-message">Por favor agregar edad</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* 👈 NUEVO - CIUDAD */}
          <div className="inp">
            <input
              className="inp-reg"
              type="text"
              placeholder="Ciudad donde vives"
              id="ciudad"
              name="ciudad"
              value={ciudad}
              onChange={(e) => setCiudad(e.target.value)}
            />
            {ciudadError && (
              <>
                <div className="error-message">Por favor agrega tu ciudad</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* 👈 NUEVO - ¿TIENE MOTO? */}
          {/* 👈 ¿TIENE MOTO? - versión pills */}
          <div className="inp inp-moto">
            <label className="moto-question-label">¿Tienes moto?</label>
            <div className="moto-options">
              <label
                className={`moto-option ${tieneMoto === "si" ? "selected" : ""}`}
              >
                <input
                  type="radio"
                  name="tieneMoto"
                  value="si"
                  checked={tieneMoto === "si"}
                  onChange={(e) => setTieneMoto(e.target.value)}
                />
                Sí
              </label>
              <label
                className={`moto-option ${tieneMoto === "no" ? "selected" : ""}`}
              >
                <input
                  type="radio"
                  name="tieneMoto"
                  value="no"
                  checked={tieneMoto === "no"}
                  onChange={(e) => {
                    setTieneMoto(e.target.value);
                    setCualMoto("");
                    setCualMotoError(false);
                  }}
                />
                No
              </label>
            </div>

            {tieneMotoError && (
              <>
                <div className="error-message">Por favor indique si tiene moto</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* 👈 NUEVO - CAMPO CONDICIONAL: solo aparece si dice "sí" */}
          {tieneMoto === "si" && (
            <div className="inp">
              <input
                className="inp-reg"
                type="text"
                placeholder="¿Cuál moto tiene?"
                id="cualMoto"
                name="cualMoto"
                value={cualMoto}
                onChange={(e) => setCualMoto(e.target.value)}
              />
              {cualMotoError && (
                <>
                  <div className="error-message">Por favor indica cuál moto tienes</div>
                  <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
                </>
              )}
            </div>
          )}

          {/* PASS */}
          <div className="inp">
            <input
              className="inp-reg"
              type={showPass ? "text" : "password"}
              placeholder="Contraseña"
              id="password"
              name="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              className="show-pass"
              onClick={() => setShowPass((p) => !p)}
              alt=""
              src={
                process.env.PUBLIC_URL +
                (showPass
                  ? "/images/icons/open-eye.svg"
                  : "/images/icons/close-eye.svg")
              }
            />

            {passwordError && (
              <>
                <div className="error-message">La contraseña debe tener entre 8 y 12 caracteres</div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          {/* TERMS */}
          <div className="term-container">
            <input type="checkbox" name="acepto" onChange={(e) => setAcepto(e.target.checked)} />
            <label>
              Aceptar los{" "}
              <a onClick={() => navigate("/privacy-policy")}>
                <strong className="text-black-brand">Términos y Condiciones</strong>.
              </a>
            </label>

            {aceptoError && (
              <>
                <div className="error-message checkbox-error-message">
                  Debe aceptar los términos y condiciones
                </div>
                <img src={process.env.PUBLIC_URL + "/images/register/iconError.svg"} className="img-error" alt="" />
              </>
            )}
          </div>

          <span className="error-msg">{errorMsg}</span>

          <button type="submit" className="btn lightgreen-btn mb-4 mt-5 uppercase" id="register" onClick={register}>
            Registrarse
          </button>

          <button className="btn black-btn uppercase" id="reg-cancel" onClick={() => navigate("/login")}>
            Cancelar
          </button>

          <div className="reg-separator"></div>
        </div>
      </div>

      {activePopup ? <PopupRegister user={user} /> : null}
      {loadingRegister ? <Loader /> : null}
    </>
  );
}

export default Register;